"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
const checkArgumentValidity_1 = require("../common/checkArgumentValidity");
exports.requestSchema = zod_1.z
    .object({
    propertyId: zod_1.z.number(),
})
    .refine(checkArgumentValidity_1.checkIfOneArgumentIsUsed, { message: 'Only one selector may be used to query soil property data.' });
//# sourceMappingURL=soilMAD.js.map